import { locationLine } from "@vidario/domain";
import { cn } from "@vidario/ui";
import { MapPin } from "lucide-react";
import { type ReactElement } from "react";

interface CandidateLocationProps {
  /** The shown candidate's location: in the Anonym-Ansicht already the country (#146). */
  location: string | null;
  distanceKm: number | null;
  /** The job's Standort: the distance is worded from its town (#186). */
  jobLocation: string | null;
  anonym: boolean;
  /** The candidate page shows the distance in its own chip. */
  withDistance?: boolean;
  className?: string;
}

/** Where a candidate lives: the stored location, or in the Anonym-Ansicht the
 * country and distance instead of the town (#146). */
export function CandidateLocation({
  location,
  distanceKm,
  jobLocation,
  anonym,
  withDistance = true,
  className,
}: CandidateLocationProps): ReactElement | null {
  const shown = locationLine(location, withDistance ? distanceKm : null, anonym, jobLocation);
  if (!shown) return null;
  return (
    <div className={cn("inline-flex items-center gap-1 text-xs text-text-tertiary", className)}>
      <MapPin size={12} aria-hidden="true" />
      <span aria-hidden={shown.spoken !== shown.text}>{shown.text}</span>
      {shown.spoken !== shown.text && <span className="sr-only">{shown.spoken}</span>}
    </div>
  );
}
